/* Cuddypup: keep the theme cart drawer synchronized after Mageworx add-ons. */
(() => {
  if (window.__cuddypupMageworxCartSync) return;
  window.__cuddypupMageworxCartSync = true;

  /* Ensure the app heading remains bold and italic inside its shadow root. */
  let headingAttempts = 0;
  const installHeadingOverride = () => {
    headingAttempts += 1;
    const root = document.querySelector('mw-product-addons')?.shadowRoot;

    if (root && !root.querySelector('#cuddypup-mageworx-overrides')) {
      const style = document.createElement('style');
      style.id = 'cuddypup-mageworx-overrides';
      style.textContent = `
        .ProductAddons .ProductAddons__Heading {
          font-size: 16px !important;
          line-height: 1.3 !important;
          font-style: italic !important;
          font-weight: 700 !important;
          margin-bottom: 0 !important;
        }

        .ProductAddons > .ProductAddons__Content {
          margin-top: 8px !important;
        }

        .ProductAddons .BundleProductSelect__Content {
          color: #e95c4d !important;
          background-color: #fffdf6 !important;
          border: 1px solid #e95c4d !important;
          border-radius: 4px !important;
          box-shadow: none !important;
          font-size: 13px !important;
          line-height: 18px !important;
          padding: 6px 8px !important;
        }

        .ProductAddons .BundleProductSelect__Control option {
          color: #e95c4d !important;
          background-color: #fffdf6 !important;
        }

        .ProductAddons .ItemCheckbox__Control {
          appearance: none !important;
          -webkit-appearance: none !important;
          width: 18px !important;
          height: 18px !important;
          min-width: 18px !important;
          background-color: #fffdf6 !important;
          border: 1px solid #e8ded2 !important;
          border-radius: 4px !important;
          box-shadow: none !important;
          cursor: pointer !important;
        }

        .ProductAddons .ItemCheckbox__Control:checked {
          background-color: #e95c4d !important;
          border-color: #e95c4d !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'%3E%3Cpath d='M1 5l3 3 7-7' fill='none' stroke='%23fffdf6' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: center !important;
          background-size: 11px 9px !important;
        }

        .ProductAddons .ItemCheckbox__Control:focus-visible {
          outline: 1px solid #e95c4d !important;
          outline-offset: 2px !important;
        }

        .ProductAddons.ProductAddons {
          padding-bottom: 18px !important;
        }

        .ProductAddons .ProductAddons__ImageBlock,
        .ProductAddons .ProductAddons__Image {
          width: 72px !important;
          min-width: 72px !important;
          height: 72px !important;
        }

        .ProductAddons .ProductAddons__Image {
          background-color: #fffdf6 !important;
          border: 1px solid #e8ded2 !important;
          border-radius: 4px !important;
          box-shadow: none !important;
        }

        .ProductAddons .ProductAddons__Image img {
          width: 72px !important;
          max-width: 72px !important;
          height: auto !important;
          margin: auto 0 !important;
          object-fit: contain !important;
        }

        /* Compact customizable add-on quantity selector. Keep Mageworx's
           native buttons/input so min, max, and quantity updates still work. */
        .ProductAddons .ItemQuantity {
          display: grid !important;
          grid-template-columns: 24px 22px 24px !important;
          width: 72px !important;
          height: 30px !important;
          min-height: 30px !important;
          overflow: hidden !important;
          background: #fffdf6 !important;
          border: 1px solid #e95c4d !important;
          border-radius: 4px !important;
          box-shadow: none !important;
          box-sizing: border-box !important;
        }

        .ProductAddons .ItemQuantity__Button {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 24px !important;
          min-width: 24px !important;
          height: 28px !important;
          padding: 0 !important;
          color: #e95c4d !important;
          background: transparent !important;
          border: 0 !important;
          box-shadow: none !important;
        }

        .ProductAddons .ItemQuantity__Button:disabled {
          color: #e95c4d !important;
          opacity: 1 !important;
        }

        .ProductAddons .ItemQuantity__Button svg {
          width: 12px !important;
          height: 12px !important;
        }

        .ProductAddons .ItemQuantity__Control {
          width: 22px !important;
          min-width: 22px !important;
          height: 28px !important;
          min-height: 28px !important;
          margin: 0 !important;
          padding: 0 !important;
          color: #e95c4d !important;
          background: transparent !important;
          border: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          font-size: 12px !important;
          line-height: 28px !important;
          text-align: center !important;
        }
      `;
      root.appendChild(style);
      return true;
    }

    return headingAttempts >= 60;
  };

  if (!installHeadingOverride()) {
    const headingTimer = window.setInterval(() => {
      if (installHeadingOverride()) window.clearInterval(headingTimer);
    }, 250);
  }

  /* The shared Mageworx Custom CSS pulls every app host up by 16px for the
     product add-on widget. Restore the normal gap for the PDP bundle builder. */
  let builderSpacingAttempts = 0;
  const installBuilderSpacingOverride = () => {
    builderSpacingAttempts += 1;
    const host = [...document.querySelectorAll('mw-pdp-offer')]
      .find((element) => element.shadowRoot?.textContent.includes('Build your bundle'));
    const root = host?.shadowRoot;

    if (root && !root.querySelector('#cuddypup-mageworx-builder-spacing')) {
      const style = document.createElement('style');
      style.id = 'cuddypup-mageworx-builder-spacing';
      style.textContent = `
        :host {
          display: block !important;
          margin-top: 0 !important; /* Increase for more space above the bundle heading. */
        }

        /* Center the heading and progress badge between two divider lines. */
        .HeaderContent-Boxes--header,
        .HeaderContent-Flexy--header {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
        }

        .HeaderContent-Boxes--header::before,
        .HeaderContent-Boxes--header::after,
        .HeaderContent-Flexy--header::before,
        .HeaderContent-Flexy--header::after {
          content: "" !important;
          flex: 1 1 0 !important;
          height: 1px !important;
          background: #E8DED2 !important;
        }

        /* Tier boxes: subtle at rest, coral on hover and selection. */
        .HeaderContent-BoxSelector--box,
        .CartContent-BoxSelector--box {
          color: #e95c4d !important;
          background: #FFFDF6 !important;
          border-color: #E8DED2 !important;
          transition: color .3s ease, border-color .3s ease, background-color .3s ease !important;
        }

        .HeaderContent-BoxSelector--box:hover,
        .CartContent-BoxSelector--box:hover {
          color: #e95c4d !important;
          border-color: #e95c4d !important;
        }

        .HeaderContent-BoxSelector--box.HeaderContent-BoxSelector--selected,
        .CartContent-BoxSelector--box.CartContent-BoxSelector--selected {
          color: #e95c4d !important;
          background: #FFFDF6 !important;
          border-color: #e95c4d !important;
        }

        /* Compact the total while giving the bundle CTA slightly more emphasis. */
        .PdpFooterContent-Price__PriceText {
          font-size: 15px !important;
          line-height: 1.25 !important;
        }

        .PdpFooterContent-Price__PriceAmount {
          font-size: 18px !important;
          line-height: 1.25 !important;
        }

        .PdpFooterContent-Price__PriceAmountStrikethrough,
        .PdpFooterContent-Price__PriceSave {
          font-size: 15px !important;
          line-height: 1.25 !important;
        }

        .PdpFooterContent-AddToCartButton__Button,
        .PdpFooterContent-AddToCartButton__ButtonText {
          font-size: 16px !important;
          line-height: 1.2 !important;
        }
      `;
      root.appendChild(style);

      const updateBundleButtonLabel = () => {
        const buttonText = root.querySelector(
          '.PdpFooterContent-AddToCartButton__ButtonText'
        );
        if (buttonText && buttonText.textContent.trim() !== 'Add bundle to cart') {
          buttonText.textContent = 'Add bundle to cart';
        }
      };

      updateBundleButtonLabel();
      if (!root.__cuddypupBundleButtonLabelObserver) {
        const observer = new MutationObserver(updateBundleButtonLabel);
        observer.observe(root, { childList: true, subtree: true, characterData: true });
        root.__cuddypupBundleButtonLabelObserver = observer;
      }

      return true;
    }

    return builderSpacingAttempts >= 60;
  };

  if (!installBuilderSpacingOverride()) {
    const builderSpacingTimer = window.setInterval(() => {
      if (installBuilderSpacingOverride()) window.clearInterval(builderSpacingTimer);
    }, 250);
  }

  /* Restyle the fixed frequently-bought-together offer inside Mageworx's
     open shadow root. Keep the app's pricing, variants, and cart logic intact. */
  const bundleOfferCss = `
    :host {
      display: block !important;
      margin-bottom: 28px !important;
    }

    .BundleOffer__Content {
      align-items: stretch !important;
    }

    .BundleOffer__Image {
      width: 100px !important;
      height: 100px !important;
      max-height: none !important;
      aspect-ratio: 1 / 1 !important;
    }

    .BundleOffer__Image::after {
      display: none !important;
      padding-bottom: 0 !important;
    }

    .BundleOffer__Image img {
      width: 100% !important;
      height: 100% !important;
      max-width: none !important;
      max-height: none !important;
      object-fit: cover !important;
    }

    .BundleOffer__Title {
      font-size: 13px !important;
      font-weight: 600 !important;
      line-height: 1.25 !important;
    }

    .BundleOffer__TitleWrapper {
      row-gap: 3px !important;
    }

    .BundleOffer__Price {
      font-size: 13px !important;
      font-weight: 500 !important;
      line-height: 1.25 !important;
    }

    /* Mageworx uses Select__Content for one combined variant selector and
       MultipleSelect__Content only when product options are split. */
    .Select__Content,
    .MultipleSelect__Content {
      height: 25px !important;
      min-height: 25px !important;
      color: #e95c4d !important;
      background-color: #fffdf6 !important;
      border: 1px solid #e95c4d !important;
      border-radius: 4px !important;
      box-shadow: none !important;
      font-size: 12px !important;
      line-height: 17px !important;
      padding: 3px 8px !important;
    }

    .Select__Control option,
    .MultipleSelect__Control option {
      color: #e95c4d !important;
      background-color: #fffdf6 !important;
    }

    .Select__Icon svg,
    .MultipleSelect__Icon svg {
      width: 16px !important;
      height: 16px !important;
      color: #e95c4d !important;
    }

    .BundleOffer .Select,
    .BundleOffer .MultipleSelect__Select {
      margin-top: 2px !important;
    }

    .TotalPriceTitle,
    .YouSaveTitle,
    .TotalPriceWrap > p:first-child {
      font-size: 14px !important;
      line-height: 1.3 !important;
    }

    .TotalPriceTitle::after,
    .YouSaveTitle::after,
    .TotalPriceWrap > p:first-child::after {
      content: ":" !important;
    }

    .TotalPriceDiscounted,
    .Discount,
    .TotalPriceWrap > .TotalPrice {
      font-size: 15px !important;
      font-weight: 500 !important;
      line-height: 1.3 !important;
    }

    .BundleOffer__TotalPriceBlock {
      gap: 8px !important;
    }

    /* Pull only the savings row closer to Total Price without reducing the
       spacing between the savings row and the purchase button. */
    .BundleOffer__TotalPriceBlock > .DiscountWrap {
      margin-top: -4px !important;
    }

    .BundleOffer__TotalPriceBlock button,
    .BundleOffer__TotalPriceBlock button * {
      font-weight: 500 !important;
      text-transform: uppercase !important;
    }

    .BundleOffer__TotalPriceBlock .Button,
    .BundleOffer__TotalPriceBlock button {
      transition: background-color .2s ease, border-color .2s ease, color .2s ease !important;
    }

    .BundleOffer__TotalPriceBlock .Button:hover,
    .BundleOffer__TotalPriceBlock .Button:focus-visible,
    .BundleOffer__TotalPriceBlock button:hover,
    .BundleOffer__TotalPriceBlock button:focus-visible {
      --background-color: #5b89fb !important;
      --text-color: #fffdf6 !important;
      background: #5b89fb !important;
      background-color: #5b89fb !important;
      background-image: none !important;
      border-color: #5b89fb !important;
      color: #fffdf6 !important;
      opacity: 1 !important;
    }

    .BundleOffer__TotalPriceBlock .Button:hover *,
    .BundleOffer__TotalPriceBlock .Button:focus-visible *,
    .BundleOffer__TotalPriceBlock button:hover *,
    .BundleOffer__TotalPriceBlock button:focus-visible * {
      color: #fffdf6 !important;
      opacity: 1 !important;
    }

    .BundleOffer--md .BundleOffer__Image {
      width: 135px !important;
      height: 135px !important;
    }

    .BundleOffer--md .BundleOffer__Item {
      width: 135px !important;
      max-width: 135px !important;
      gap: 6px !important;
    }

    .BundleOffer--md .BundleOffer__Item:not(:nth-last-of-type(2))::after {
      content: "+" !important;
      display: grid !important;
      place-items: center !important;
      width: 28px !important;
      height: 28px !important;
      right: -36px !important;
      top: 54px !important;
      color: #e95c4d !important;
      background: none !important;
      font-size: 30px !important;
      font-weight: 400 !important;
      line-height: 1 !important;
    }

    .BundleOffer--md .BundleOffer__TotalPriceBlock {
      align-self: flex-start !important;
      align-items: flex-start !important;
      justify-content: flex-end !important;
      height: 135px !important;
      min-width: 155px !important;
    }

    @media (max-width: 749px) {
      :host {
        margin-bottom: 24px !important;
      }

      .BundleOffer__Content {
        gap: 18px !important;
      }

      .BundleOffer__TotalPriceBlock {
        align-items: flex-start !important;
      }
    }
  `;

  const installBundleOfferOverride = (host) => {
    const root = host?.shadowRoot;
    if (!root || root.querySelector('#cuddypup-mageworx-bundle-offer-style')) {
      return Boolean(root);
    }

    const style = document.createElement('style');
    style.id = 'cuddypup-mageworx-bundle-offer-style';
    style.textContent = bundleOfferCss;
    root.appendChild(style);
    return true;
  };

  const scanBundleOffers = () => {
    document.querySelectorAll('mw-bundle-offer').forEach(installBundleOfferOverride);
  };

  scanBundleOffers();
  const bundleOfferObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('mw-bundle-offer')) installBundleOfferOverride(node);
        node.querySelectorAll?.('mw-bundle-offer').forEach(installBundleOfferOverride);
      });
    });
  });
  bundleOfferObserver.observe(document.documentElement, { childList: true, subtree: true });

  let bundleOfferAttempts = 0;
  const bundleOfferTimer = window.setInterval(() => {
    bundleOfferAttempts += 1;
    scanBundleOffers();
    if (
      bundleOfferAttempts >= 120 ||
      [...document.querySelectorAll('mw-bundle-offer')].some(
        (host) => host.shadowRoot?.querySelector('#cuddypup-mageworx-bundle-offer-style')
      )
    ) {
      window.clearInterval(bundleOfferTimer);
    }
  }, 250);

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const requestUrl = String(args[0]?.url || args[0] || '');
    const requestOptions = args[1] || {};
    let requestBody = null;

    if (typeof requestOptions.body === 'string') {
      try {
        requestBody = JSON.parse(requestOptions.body);
      } catch (_) {
        requestBody = null;
      }
    }

    const isMageworxQueryAdd =
      requestUrl.includes('/cart/add.js') &&
      requestUrl.includes('app=mwsmoffers');

    const isMageworxBuilderAdd =
      requestUrl.includes('/cart/add.js') &&
      Array.isArray(requestBody?.items) &&
      requestBody.items.some((item) => {
        const properties = item?.properties || {};
        return (
          '__mw_build' in properties ||
          '_mw_marketing_offers_offer_id' in properties
        );
      });

    if (response.ok && (isMageworxQueryAdd || isMageworxBuilderAdd)) {
      window.setTimeout(() => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        if (typeof drawer.refresh === 'function') drawer.refresh();
        if (typeof drawer.open === 'function') drawer.open();
      }, 350);
    }

    return response;
  };
})();
